(function () {

    'use strict';

    angular.module('BBPublicBooking').service('bbWidgetUtilities', BBWidgetUtilities);

    function BBWidgetUtilities($window, BBModel, bbWidgetPage, bbWidgetStep, AppService, $timeout, LoginService, $location, $anchorScroll) {

        let $scope = null;
        const setScope = function ($s) {
            $scope = $s;
        };

        const isAdmin = function () {
            return $scope.bb.isAdmin;
        };
        const showLoaderHandler = function () {
            $scope.loading = true;
        };
        const hideLoaderHandler = function () {
            $scope.loading = false;
        };
        const locationChangeStartHandler = function (angular_event, new_url, old_url) {
            let step_number;
            if (!$scope.bb.routeFormat) {
                return;
            }
            if (!$scope.bb.routing || AppService.isModalOpen()) {
                step_number = $scope.bb.matchURLToStep();
                if (step_number > $scope.bb.current_step) {
                    bbWidgetStep.loadStep(step_number);
                } else if (step_number < $scope.bb.current_step) {
                    bbWidgetStep.loadPreviousStep('locationChangeStart');
                }
            }
            $scope.bb.routing = false;
        };
        const getPartial = function (file) {
            return $scope.bb.pageURL(file);
        };
        const logout = function (route) {
            if ($scope.client && $scope.client.valid()) {
                return LoginService.logout({
                    root: $scope.bb.api_url
                }).then(() => {
                    $scope.client = new BBModel.Client();
                    return bbWidgetPage.decideNextPage(route);
                });
            } else if ($scope.member) {
                return LoginService.logout({
                    root: $scope.bb.api_url
                }).then(() => {
                    $scope.member = new BBModel.Member.Member();
                    return bbWidgetPage.decideNextPage(route);
                });
            }
        };
        const setRoute = function (rdata) {
            return $scope.bb.setRoute(rdata);
        };
        const getUrlParam = function (param) {
            return $window.getURIparam(param);
        };
        const base64encode = function (param) {
            return $window.btoa(param);
        };
        const broadcastItemUpdate = function (state = null) {
            return $scope.$broadcast('currentItemUpdate', $scope.bb.current_item, state);
        };
        const isAdminIFrame = function () {
            let location;
            if (!$scope.bb.isAdmin) {
                return false;
            }
            try {
                location = $window.parent.location.href;
                if (location && $window.parent.reload_dashboard) {
                    return true;
                } else {
                    return false;
                }
            } catch (_error) {
                return false;
            }
        };
        const reloadDashboard = function () {
            return $window.parent.reload_dashboard();
        };
        const $debounce = function (tim) {
            if ($scope._debouncing) {
                return false;
            }
            tim || (tim = 100);
            $scope._debouncing = true;
            return $timeout(() => {
                return $scope._debouncing = false;
            }, tim);
        };
        const supportsTouch = function () {
            return Modernizr.touch;
        };
        const isMemberLoggedIn = function () {
            return LoginService.isLoggedIn();
        };
        const scrollTo = function (id) {
            $location.hash(id);
            $anchorScroll();
        };
        const redirectTo = function (url) {
            return $window.location.href = url;
        };

        return {
            setScope,
            isAdmin,
            showLoaderHandler,
            hideLoaderHandler,
            locationChangeStartHandler,
            getPartial,
            logout,
            setRoute,
            getUrlParam,
            base64encode,
            broadcastItemUpdate,
            isAdminIFrame,
            reloadDashboard,
            $debounce,
            supportsTouch,
            isMemberLoggedIn,
            scrollTo,
            redirectTo
        };
    }

})();



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/widget/bb_widget_utilities.service.js